export default __webpack_public_path__ + "static/media/adebayo.ce4bb4d1.jpg";